import i18next from '../../config/i18next';

i18next.addResources('es', 'Validations', {
  requiredValidationLarge: 'Este campo es requerido',
  requiredValidation: 'Requerido',
  requiredaux: 'Requerido',
  emailValidation: 'Formato de email inválido',
  emailSymbol: 'Formato de email inválido, no puede contener el simbolo +',
  lessOrEqualThanValidation: 'El campo no debe ser mayor a {{data}}',
  greaterOrEqualThanValidation: 'El campo debe ser mayor a {{data}}',
  timeValidation: 'Hora inválida, el formato debe ser hh:mm',
  hourLessThanValidation: 'Esta hora no puede ser mayor a hora hasta',
  equalToValidation: 'Las contraseñas no coinciden',
  containCapitalLetterValidation: 'Debe contener mayúsculas',
  containLowerLetterValidation: 'Debe contener minúsculas',
  containNumberValidation: 'Debe contener al menos un número',
  greaterOrEqualThanStringValidation: 'Debe tener al menos {{data}} caracteres',
  lessOrEqualThanStringValidation:
    'El campo no debe ser mayor a {{data}} caracteres',
  fileFormatValidation: 'La extensión del archivo es inválido',
  numberValidate: 'El valor ingresado debe ser numérico.',
  maxCharatetLengthValidation: 'Ha excedido el valor maximo requerido',
  onlyWordsAndSpace: 'Solo puede contener letras y espacios',
  onlyNumbers: 'Solo nros seguidos',
  WithoutSpecialCharacters: 'Solo puede contener letras, espacios y números',
});

i18next.addResources('es', 'MultiImageInput', {
  PlaceholderTitle: 'Parece que no hay imágenes cargadas todavía',
  ImageTypes: 'Tipo de archivo: PNG, JPG, JPEG.',
  ImageSize: 'Tamaño máximo: 5 MB.',
  UploadImage: 'Cargar imagen',
});

i18next.addResources('es', 'NavBar', {
  title: 'MENU',
  admin: 'ADMIN',
  logout: 'Cerrar sesión',
});
